import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreditCard } from "lucide-react";
import PortalShellPageHeader from "../../components/Layout/PortalShellPageHeader/PortalShellPageHeader";
import portalStyles from "../../layout/portalPageShell.module.css";
import styles from "./BillingPage.module.css";
import SubscriptionManageInline from "./SubscriptionManageInline";
import ManagePlans from "../../components/Layout/BillingComponents/ManagePlans";
import ManageDomains from "../../components/Layout/BillingComponents/ManageDomains";
import BillingHistory from "../../components/Layout/BillingComponents/BillingHistory";
import ErrorBoundary from "../../components/UI/ErrorBoundary/ErrorBoundary";

export default function BillingPage() {
  const { t } = useTranslation("common");
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("plans");

  const params = new URLSearchParams(location.search);
  const isSubscriptionManagingMode = Boolean(
    params.get("id") && params.get("product") && params.get("tier")
  );

  useEffect(() => {
    if (isSubscriptionManagingMode) {
      setActiveTab("plans");
      return;
    }

    const nextTab = location?.state?.tab;
    if (
      nextTab === "plans" ||
      nextTab === "domains" ||
      nextTab === "history"
    ) {
      setActiveTab(nextTab);
    }
  }, [location?.key, isSubscriptionManagingMode, location?.state?.tab]);

  return (
    <div className={portalStyles.portalPage}>
      <div className={portalStyles.container}>
        <PortalShellPageHeader
          icon={<CreditCard size={28} strokeWidth={1.75} absoluteStrokeWidth />}
          title={t("billingPage.title")}
          subtitle={t("billingPage.subtitle")}
        />

        <div className={styles.billingMain}>
          {isSubscriptionManagingMode && <SubscriptionManageInline />}

          <div className={styles.tabNavigation}>
            <button
              type="button"
              className={`${styles.tabButton} ${
                activeTab === "plans" ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab("plans")}
            >
              {t("billingPage.tabs.managePlans")}
            </button>
            <button
              type="button"
              className={`${styles.tabButton} ${
                activeTab === "domains" ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab("domains")}
            >
              {t("billingPage.tabs.manageDomains")}
            </button>
            <button
              type="button"
              className={`${styles.tabButton} ${
                activeTab === "history" ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab("history")}
            >
              {t("billingPage.tabs.billingHistory")}
            </button>
          </div>

          {activeTab === "plans" && (
            <ErrorBoundary>
              <ManagePlans />
            </ErrorBoundary>
          )}

          {activeTab === "domains" && (
            <ErrorBoundary>
              <ManageDomains />
            </ErrorBoundary>
          )}

          {activeTab === "history" && (
            <ErrorBoundary>
              <BillingHistory />
            </ErrorBoundary>
          )}
        </div>
      </div>
    </div>
  );
}
